<div class="app__container mt-10 flex flex-col gap-6">
	<h2 class="flex text-left text-primary-900">Nuevo usuario</h2>

	<app-create-admin-form
		[loading]="loading()"
		(formSubmit)="onFormSubmit($event)"
	/>
</div>
